import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useToast } from '../hooks/use-toast';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Newsletter = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    try {
      await axios.post(`${BACKEND_URL}/api/newsletter/subscribe`, { email });
      toast({
        title: t('newsletter.subscribed'),
        description: t('newsletter.subscribedDesc'),
      });
      setEmail('');
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      toast({
        title: t('newsletter.error'),
        description: error.response?.data?.detail || t('newsletter.errorMessage'),
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-[#102131] to-[#1a3449] text-[#F7FDFF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#CDA259]/20 rounded-full mb-6">
            <Mail size={32} className="text-[#CDA259]" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            {t('newsletter.title')}
          </h2>
          <p className="text-lg text-[#F7FDFF]/80 mb-8">
            {t('newsletter.subtitle')}
          </p>
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto">
            <Input
              type="email"
              placeholder={t('newsletter.placeholder')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-white/10 border-[#CDA259]/30 text-[#F7FDFF] placeholder:text-[#F7FDFF]/50 focus:border-[#CDA259]"
              required
            />
            <Button
              type="submit"
              disabled={isLoading}
              className="bg-[#CDA259] text-[#102131] hover:bg-[#CDA259]/90 font-semibold px-8 transition-all duration-200 hover:scale-105"
            >
              {isLoading ? t('newsletter.subscribing') : t('newsletter.subscribe')}
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
